import { SportType } from './global.model';

export enum InteractivityType {
  CLASSIC = 'classic',
  SMART = 'smart',
  INTERACTIVE = 'interactive'
}

export enum EquipmentType {
  HOME_TRAINER = 'home_trainer',
  EXERCISE_BIKE = 'exercise_bike',
  TREADMILL = 'treadmill',
  ELLIPTICAL = 'elliptical',
  ROWING_MACHINE = 'rowing_machine'
}

export interface Equipment {
  equipment_name: string;
  equipment_interactivity: InteractivityType;
  equipment_sport_type: SportType;
  equipment_manufacturer_name: string;
  equipment_manufacturer_image_url: string;
  equipment_type: EquipmentType;
}

export type Equipments = Array<Equipment>;
